var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg404Graphic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1935 19.3548H25.8065V62.9032H74.1935V19.3548Z",
    fill: "#EB6087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9355 100H8.06452C3.61774 100 0 96.3823 0 91.9355V83.871H29.0323V87.0968H3.22581V91.9355C3.22581 94.6032 5.39677 96.7742 8.06452 96.7742H91.9355C94.6032 96.7742 96.7742 94.6032 96.7742 91.9355V87.0968H70.9677V83.871H100V91.9355C100 96.3823 96.3823 100 91.9355 100Z",
    fill: "#02042C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9032 93.5484H37.0968C34.429 93.5484 32.2581 91.3774 32.2581 88.7097V83.871H67.7419V88.7097C67.7419 91.3774 65.571 93.5484 62.9032 93.5484ZM35.4839 87.0968V88.7097C35.4839 89.5984 36.2065 90.3226 37.0968 90.3226H62.9032C63.7935 90.3226 64.5161 89.5984 64.5161 88.7097V87.0968H35.4839Z",
    fill: "#02042C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9032 90.3226H9.67742V93.5484H12.9032V90.3226Z",
    fill: "#02042C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3548 90.3226H16.129V93.5484H19.3548V90.3226Z",
    fill: "#02042C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8065 90.3226H22.5806V93.5484H25.8065V90.3226Z",
    fill: "#02042C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7742 80.6452H93.5484V24.1935C93.5484 21.5258 91.3774 19.3548 88.7097 19.3548H83.871V16.129H88.7097C93.1564 16.129 96.7742 19.7468 96.7742 24.1935V80.6452Z",
    fill: "#02042C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45161 80.6452H3.22581V24.1935C3.22581 19.7468 6.84355 16.129 11.2903 16.129H16.129V19.3548H11.2903C8.62258 19.3548 6.45161 21.5258 6.45161 24.1935V80.6452Z",
    fill: "#02042C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3226 80.6452H87.0968V25.8064H83.871V22.5806H87.0968C88.8758 22.5806 90.3226 24.0274 90.3226 25.8064V80.6452Z",
    fill: "#02042C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9032 80.6452H9.67742V25.8064C9.67742 24.0274 11.1242 22.5806 12.9032 22.5806H16.129V25.8064H12.9032V80.6452Z",
    fill: "#02042C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6452 16.129H19.3548V0H80.6452V16.129ZM22.5806 12.9032H77.4194V3.22581H22.5806V12.9032Z",
    fill: "#EB6087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0323 6.45161H25.8065V9.67742H29.0323V6.45161Z",
    fill: "#EB6087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4839 6.45161H32.2581V9.67742H35.4839V6.45161Z",
    fill: "#EB6087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9355 6.45161H38.7097V9.67742H41.9355V6.45161Z",
    fill: "#EB6087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6452 69.3548H19.3548V19.3548H22.5806V66.129H77.4194V19.3548H80.6452V69.3548Z",
    fill: "#02042C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0968 54.8387H33.871V50H25.8065V46.4323L32.8242 30.6452H37.0968V46.7742H40.3226V50H37.0968V54.8387ZM29.1855 46.7742H33.871V36.229L29.1855 46.7742Z",
    fill: "#02042C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9677 54.8387H67.7419V50H59.6774V46.4323L66.6952 30.6452H70.9677V46.7742H74.1935V50H70.9677V54.8387ZM63.0565 46.7742H67.7419V36.229L63.0565 46.7742Z",
    fill: "#02042C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 53.2258C45.5532 53.2258 41.9355 49.6081 41.9355 45.1613V38.7097C41.9355 34.2629 45.5532 30.6452 50 30.6452C54.4468 30.6452 58.0645 34.2629 58.0645 38.7097V45.1613C58.0645 49.6081 54.4468 53.2258 50 53.2258ZM50 33.871C47.3323 33.871 45.1613 36.0419 45.1613 38.7097V45.1613C45.1613 47.829 47.3323 50 50 50C52.6677 50 54.8387 47.829 54.8387 45.1613V38.7097C54.8387 36.0419 52.6677 33.871 50 33.871Z",
    fill: "#02042C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg404Graphic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/404-graphic.228db772c350c5d75ebd6316cc2f9bc8.svg";